<template>
    <recipe-filters
        v-editable="blok"
        @selectionChange="onFiltersChange"
        :excludedGroups="meal_preferences.excluded_groups"
        :mealPlan="meal_preferences.meal_plan"
        :blok="blok"
    ></recipe-filters>
</template>
<script>
import { mapActions, mapState } from "vuex";
import RecipeFilters from "../recipes/RecipeFilters";

export default {
  name: "profile-meal-preferences",
  props: {
    blok: Object
  },
  components: {
    RecipeFilters
  },
  computed: {
    ...mapState({
        meal_preferences: state => state.profile.meal_preferences
    })
  },
  methods: {
    ...mapActions("profile", ["updateMealPreferences"]),
    onFiltersChange(filters) {
      this.updateMealPreferences({
        groups: filters.groups.map(v=>v.name),
        plan: filters.plan ? filters.plan.name:null
      });
    }
  }
};
</script>